import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { AppModel } from "../../../app/app-model";
import { AddTable } from "../../../components/ui-kit/tables/add-table";
import { CellDateInput } from "../../../components/ui-kit/tables/cell-fields/cell-date-input";
import { CellTextInput } from "../../../components/ui-kit/tables/cell-fields/cell-text-input";
import { CellRemoveButton } from "../../../components/ui-kit/tables/cells/cell-remove-button";
import { getVariableByName } from "../../../utils/data-utils";
import { CellGenericValueField } from "../common/cell-generic-value-field";
import { Patient } from "../patient";
import { AddEcho } from "./add-echo";
import { AddLHC } from "./add-lhc";
import { AddOtherExams } from "./add-other-exams";

export const AddExamsTable = observer(function AddExamsTable(props: {
  app: AppModel;
  variant: "exams" | "echo" | "lhc";
}) {
  const patient = props.app.requirePatient();
  const [model] = useState(() => {
    const m = getTable(props.variant, patient);
    void m.initEmpty();
    return m;
  });

  return (
    <AddTable
      model={model}
      canAddRows={false}
      setAllDates="datetime"
      columns={[
        {
          header: <Trans>Measured at</Trans>,
          cell: (item) => (
            <CellDateInput
              attr="measurement_datetime"
              model={item}
              type="datetime-local"
            />
          ),
        },
        {
          header: <Trans>Type</Trans>,
          cell: (item) => (
            <label>
              {item.measurement_type.charAt(0).toUpperCase() +
                item.measurement_type.slice(1)}
            </label>
          ),
        },
        {
          header: <Trans>Value</Trans>,
          cell: (item) => (
            <CellGenericValueField
              model={item}
              attr="measurement_value"
              variableDef={getVariableByName(
                model.supportedVariables,
                item.measurement_type,
              )}
            />
          ),
        },
        {
          header: <Trans>Unit</Trans>,
          cell: (item) => <label>{item.measurement_unit}</label>,
        },
        {
          header: <Trans>Comment</Trans>,
          cell: (item) => (
            <CellTextInput attr="comment" model={item} multiline="autosize" />
          ),
        },
        {
          header: <Trans>Remove row</Trans>,
          cell: (item, index) => (
            <CellRemoveButton index={index} model={model} />
          ),
        },
      ]}
    />
  );
});

function getTable(variant: "exams" | "echo" | "lhc", patient: Patient) {
  switch (variant) {
    case "exams":
      return new AddOtherExams(patient.api, patient);
    case "echo":
      return new AddEcho(patient.api, patient);
    case "lhc":
      return new AddLHC(patient.api, patient);
  }
}
